/** Navigates from outside Atlantic UI's navigation, e.g. a toolbar button. */
export function goTo(path: string) {
  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
